var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled from 'styled-components';
var Nav = styled.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: none;\n  color: ", ";\n  display: flex;\n  list-style: none;\n  width: max-content;\n"], ["\n  background-color: none;\n  color: ", ";\n  display: flex;\n  list-style: none;\n  width: max-content;\n"])), function (p) {
  return p.theme.highContrast;
});

var NavSub = function NavSub(_a) {
  var children = _a.children;
  return React.createElement(Nav, {
    className: "navbar"
  }, children);
};

export default NavSub;
var templateObject_1;